import { useState, useEffect, useCallback, useRef } from "react";
import "./FontComponent.css";

import { useDispatch, useSelector } from "react-redux";
import { LowerCase, UpperCase, SmallCaps, UnderLine, iconOne, iconTwo, None } from "../../../../../assets/icons/index";
import { updateFontStyleState, saveFontStyle } from "../../../../../Redux/actions/projectActions";
import {
  Radio,
  Dropdown,
  ColorPicker,
  Number_point_Input,
  NumberInput_fontsize,
  Dropdown_fontFamily,
  RadioFont,
  NumberInput_pointFont,
} from "../../../../../Components";

import Dropdown_fontFamilyto from "../../../../../Components/Dropdown/Dropdown_FontFamilyto";

import { baseURL } from "../../../../../services/axios";
import loaderGif from "../../../../../assets/icons/Loader/Scrollx_animate.gif";
import debounce from "lodash.debounce";

// Resolve the API base URL the same way axios.js does, so @font-face
// points at the Express server, not the React dev server.
// Also appends ?token= because browsers can't send custom headers for @font-face.
const getApiFontUrl = (proxyPath) => {
  const token = localStorage.getItem("authToken") ? JSON.parse(localStorage.getItem("authToken")) : "";
  // Use the exact baseURL that axios is using to make successful API calls
  return `${baseURL}${proxyPath}?token=${encodeURIComponent(token)}`;
};

//  font family is Archivo Narrow
const fontweightArchivo = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const laPetiteGazette = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontWeightColunaRounded = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold N/A", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightAll = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightNotMediumandSemiboldandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold N/A", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotMediumandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotSemoboldandExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightShowRegularandExtrabold = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotExtrabold = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotBlack = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightNotLight = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightOnlyRegularAndBold = [
  { label: "Light N/A", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold N/A", value: 800 },
  { label: "Black N/A", value: 900 },
];

const fontweightOnlyFutura = [
  { label: "Light", value: 300 },
  { label: "Regular  N/A", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semibold N/A", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

const fontweightOnlyTradeGothic = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium N/A", value: 500 },
  { label: "Semibold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extrabold", value: 800 },
  { label: "Black", value: 900 },
];

// Default weights for custom uploaded fonts
const fontweightCustom = [
  { label: "Regular", value: 400 },
  { label: "Bold", value: 700 },
];

const injectFontFaceFromUrl = (fontFamily, url) => {
  // Remove stale tag (e.g. expired S3 signed URL) before re-injecting
  const existing = document.querySelector(
    `style[data-custom-font="${fontFamily}"]`,
  );
  if (existing) existing.remove();
  const style = document.createElement("style");
  style.setAttribute("data-custom-font", fontFamily);
  style.textContent = `@font-face { font-family: '${fontFamily}'; src: url('${url}'); font-weight: normal; font-style: normal; }`;
  document.head.appendChild(style);
};

const initialOptions = [
  { label: "Archivo Narrow", value: "archivo narrow" },
  { label: "Barlow Condensed", value: "barlow condensed" },
  { label: "Barlow Semi Condensed", value: "barlow semi condensed" },
  { label: "Clear Sans", value: "clear sans" },
  { label: "Coluna Rounded", value: "Coluna Rounded" },
  { label: "Cooper Hewitt", value: "cooper hewitt" },
  { label: "Courier Pitch", value: "Courier pitch" },
  { label: "Futura", value: "futura" },
  { label: "Kanit", value: "kanit" },
  { label: "Karla", value: "karla" },
  { label: "La Petite Gazette", value: "la petite gazette" },
  { label: "Libre Baskerville", value: "libre baskerville" },
  { label: "Marion", value: "marion" },
  { label: "Montserrat", value: "montserrat" },
  { label: "Noto Sans", value: "noto sans" },
  { label: "Oswald", value: "oswald" },
  { label: "Poppins", value: "poppins" },
  { label: "Playfair Display", value: "playfair display" },
  { label: "Raleway", value: "raleway" },
  { label: "Roboto", value: "roboto" },
  { label: "Roboto Condensed", value: "roboto condensed" },
  { label: "Saira Condensed", value: "saira condensed" },
  { label: "Source Sans Pro", value: "source sans pro" },
  { label: "Space Mono", value: "space mono" },
  { label: "Teko", value: "teko" },
  { label: "Tiillium Webt", value: "tiillium webt" },
  { label: "Trade Gothic", value: "trade gothic" },
  { label: "Trade Gothic Condensed", value: "Trade Gothic Condensed" },
];

const FontComponent = ({
  label,
  type,
  currentOpen,
  setOpen,
  currentBlockType,
  isCard,
  pendingUploadedFont,
  onPendingUploadedFontApplied,
}) => {
  const dispatch = useDispatch();
  const s3CustomFonts = useSelector((state) => state?.project?.customFonts ?? [],);
 
  const {credits, currentBlock } = useSelector((state) => state?.project ?? {});
  const currentBlockData = credits?.find((block, index) => index === currentBlock?.idx && block?._id === currentBlock?.id);
  const isDoubleColumn =  currentBlockData?.options?.double_columns === true;

  const [options, setOptions] = useState(() => initialOptions);

  const [selectedID, setSelectedID] = useState("");
  const [selectedfontWeightID, setSelectedfontWeightID] = useState("");
  const [optionsForFont, setOptionsForFont] = useState([]);

  const [isApplyingFont, setIsApplyingFont] = useState(false);

  useEffect(() => {
    if (!s3CustomFonts?.length) {
      setOptions(initialOptions);
      return;
    }
    s3CustomFonts.forEach(({ fontFamily, proxyUrl }) => {
      injectFontFaceFromUrl(fontFamily, getApiFontUrl(proxyUrl));
    });
    const s3Options = s3CustomFonts.map(({ fontFamily }) => ({
      label: `⬆ ${fontFamily}`,
      value: fontFamily,
      isCustom: true,
    }));
    setOptions([...s3Options, ...initialOptions]);
  }, [s3CustomFonts]);

  useEffect(() => {
    if (!pendingUploadedFont || currentOpen !== type) return;
    const fontExists = s3CustomFonts?.some(
      ({ fontFamily }) => fontFamily === pendingUploadedFont,
    );
    if (fontExists) {
      const fontFamily = pendingUploadedFont;
      updateFontState("fontFamily", fontFamily);
      dispatch(
        saveFontStyle(
          fontStyleTypeRef.current,
          currentBlockType,
          "fontFamily",
          fontFamily,
          null,
          isCard,
        ),
      );
      onPendingUploadedFontApplied?.();
    }
  }, [pendingUploadedFont, currentOpen, type, s3CustomFonts]);

  let fontStyleType = type;
  if (currentBlockType === "nameonly" && type === "name") {
    fontStyleType = "nameOnlyStyle";
  } else {
    fontStyleType = type;
  }

  const fontStyleTypeRef = useRef(fontStyleType);
  useEffect(() => {
    fontStyleTypeRef.current = fontStyleType;
  }, [fontStyleType]);

  let fontStyle = useSelector((state) => state?.project?.fontStyle[fontStyleType]);

  useEffect(() => {
    const idx = options.findIndex((opt) => opt.value === fontStyle?.fontFamily);
    if (idx !== -1) setSelectedID(idx);
    const id = optionsForFont.findIndex(
      (opt) => opt.value === fontStyle?.fontWeight,
    );
    if (id !== -1) setSelectedfontWeightID(id);
  }, [fontStyle, options]);

  let Style = useSelector((state) => state?.project?.fontStyle?.role);

  const saveFonts = async (key, value) => {
    setIsApplyingFont(true);
    try {
      await dispatch(
        saveFontStyle(
          fontStyleType,
          currentBlockType,
          key,
          value,
          null,
          isCard,
        ),
      );
    } finally {
      setIsApplyingFont(false);
    }
  };

  const updateFontState = (key, value) => {
    dispatch(updateFontStyleState(type, key, value, currentBlockType));
  };

  const updateFontStateDebounced = debounce(updateFontState, 500);

  const handleFontHeaderClick = () => {
    if (currentOpen === type) setOpen(null);
    else setOpen(type);
  };

  const debounceTimeoutIds = useRef({});

  const debouncedSave = useCallback(
    (key, value, targetType) => {
      const timerKey = targetType ? `${targetType}:${key}` : key;
      if (debounceTimeoutIds.current[timerKey]) {
        clearTimeout(debounceTimeoutIds.current[timerKey]);
        debounceTimeoutIds.current[timerKey] = null;
      }
      debounceTimeoutIds.current[timerKey] = setTimeout(async () => {
        const saveType = targetType || fontStyleType;
        setIsApplyingFont(true);
        try {
          await dispatch(
            saveFontStyle(saveType, currentBlockType, key, value, null, isCard),
          );
        } finally {
          setIsApplyingFont(false);
        }
      }, 1000);
    },
    [dispatch, fontStyleType, currentBlockType, isCard],
  );

  const targetFontStyleType = currentBlockType === "rolename" && type === "name" ? "role" : fontStyleType;

  const displayedLineHeight =
    targetFontStyleType === "role"
      ? (Style?.lineHeight ?? fontStyle?.lineHeight ?? 1)
      : (fontStyle?.lineHeight ?? 1);

  const fontWieghtHandleSet = (fontFamily) => {
    if (!fontFamily) return fontweightAll;
    const isCustom = options.find(
      (opt) => opt.value === fontFamily && opt.isCustom,
    );
    if (isCustom) return fontweightCustom;
    if (fontFamily === "archivo narrow") return fontweightArchivo;
    if (fontFamily === "la petite gazette") return laPetiteGazette;
    if (
      fontFamily === "barlow condensed" ||
      fontFamily === "barlow semi condensed" ||
      fontFamily === "noto sans" ||
      fontFamily === "montserrat" ||
      fontFamily === "raleway" ||
      fontFamily === "saira condensed" ||
      fontFamily === "kanit" ||
      fontFamily === "poppins"
    )
      return fontweightAll;
    if (fontFamily === "roboto" || fontFamily === "clear sans")
      return fontweightNotSemoboldandExtrabold;
    if (fontFamily === "roboto condensed") return fontweightAll;
    if (
      fontFamily === "libre baskerville" ||
      fontFamily === "marion" ||
      fontFamily === "Trade Gothic Condensed"
    )
      return fontweightShowRegularandExtrabold;
    if (fontFamily === "source sans pro" || fontFamily === "tiillium webt")
      return fontweightNotMediumandExtrabold;
    if (
      fontFamily === "cooper hewitt" ||
      fontFamily === "teko" ||
      fontFamily === "oswald"
    )
      return fontweightNotExtrabold;
    if (fontFamily === "karla") return fontweightNotBlack;
    if (fontFamily === "playfair display") return fontweightNotLight;
    if (fontFamily === "space mono") return fontweightOnlyRegularAndBold;
    if (fontFamily === "Coluna Rounded" || fontFamily === "Courier pitch")
      return fontWeightColunaRounded;
    if (fontFamily === "futura") return fontweightOnlyFutura;
    if (fontFamily === "trade gothic") return fontweightOnlyTradeGothic;
    return fontweightAll;
  };

  useEffect(() => {
    setOptionsForFont(fontWieghtHandleSet(fontStyle?.fontFamily));
  }, [fontStyle?.fontFamily]);

  const isFontVisible = currentOpen === type;
  
const tooltipText = {
  Heading: "Define styling for the main section headings.",

  "Sub-Heading":
    "Define styling for the sub-headings.",

  Role:
    "Define styling for the credit role texts",

  Name:
    "Define styling for the credit name texts.",
};


  return (
    <div  className={ !isFontVisible ? "main-div" : "main-div mt-[4px] mb-[8px] bg-[#ffffff08] rounded-xl"}>
      <div className={!isFontVisible ? "main-font" : "main-font2 border-[1px] border-[#ffffff0f] rounded-xl  margin-bottom"}>
        <div className={!isFontVisible ? "heading" : "active-heading"} onClick={handleFontHeaderClick}>
          <div className="fonts-lable flex items-center">
            {label && (
              <div className=" inline-block group font-lable  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                <span className="cursor-help">{label}</span>
                {tooltipText[label] && (
                  <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                    {tooltipText[label]}
                  </span>
                )}
              </div>
            )}
          </div>

          <div className={!isFontVisible ? "heading-data" : "active_heading-data"}>
            <div className="fontHeading w-[70%] flex items-center justify-center overflow-hidden">
              <span className="truncate">{fontStyle?.fontFamily}</span>
                {isApplyingFont && (
                <img className="w-5 h-5 ml-2 object-contain" src={loaderGif} alt="applying font..."  />
              )}
            </div>
            <p className="w-[22%]  text-[#c1bad1] font-semibold fontHeading">{fontStyle?.fontSize} PX</p>
            <div className="icon-fontBox">
              {currentOpen === type ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-chevron-up"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <polyline points="6 15 12 9 18 15"></polyline>
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-chevron-down"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              )}
            </div>
          </div>
        </div>
        {!isFontVisible || (
          <div className="main-fontData">
            {/* Row 1 – Font Family + Weight */}
            <div className="main-section">
              <div className="section1">
                {/* <span className="font-img" /> */}
                <Dropdown_fontFamilyto
                  options={options}
                  value={
                    fontStyle?.fontFamily
                      ? fontStyle.fontFamily.length > 5
                        ? fontStyle.fontFamily.slice(0, 10) + "..."
                        : fontStyle.fontFamily
                      : "6646archivo narrow"
                  }
                  selectedID={selectedID}
                  onChange={(val) => {
                    updateFontState("fontFamily", val);
                    saveFonts("fontFamily", val);
                  }}
                />
              </div>
              <div className="section2">
                <Dropdown_fontFamily
                  options={optionsForFont}
                  value={fontStyle?.fontWeight}
                  selectedID={selectedfontWeightID}
                  customWidth={{ minWidth: "7.5rem" }}
                  onChange={(val) => {
                    updateFontState("fontWeight", val);
                    saveFonts("fontWeight", val);
                  }}
                />
              </div>
            </div>

            {/* Row 2 – Font Size + Transform */}
            <div className="main-section">
              <div className="section1">
                <span className=" mr-[8px] text-white text-base">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#c7c0d9"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width={20}
                    height={20}
                  >
                    <path d="M4 7V4h16v3M9 20h6M12 4v16" />
                  </svg>
                </span>
                <NumberInput_fontsize
                  step="1"
                  min="8"
                  max="99"
                  value={fontStyle?.fontSize}
                  onChange={(val) => {
                    const num = Number(val);
                    updateFontState("fontSize", num);
                    const clamped = Math.min(Math.max(num, 8), 99);
                    debouncedSave("fontSize", clamped);
                  }}
                  postLabel="px"
                  inputBox
                />
              </div>
              <div className="section2">
                <RadioFont
                  options={[
                    { icon: None, value: "none" },
                    { icon: UpperCase, value: "uppercase" },
                    { icon: SmallCaps, value: "capitalize" },
                    { icon: LowerCase, value: "lowercase" },
                    { icon: UnderLine, value: "underline" },
                  ]}
                  value={fontStyle?.textTransform}
                  onChange={(val) => {
                    if (val === "underline") {
                      updateFontState("textDecoration", val);
                    } else {
                      updateFontState("textDecoration", "none");
                      updateFontState("textTransform", val);
                    }
                    saveFonts();
                  }}
                  withIcon
                />
              </div>
            </div>

            {/* Row 3 – Line Height + Color */}
            <div className="main-section">
              <div className="section1">
                <img className="font-img" src={iconOne} alt="" />
                <NumberInput_pointFont
                  step="0.10"
                  min="0.80"
                  max="5.0"
                  comp="lineHeight"
                  // Temporary comment if Need common LineHeight then enable commented Value code
                  // value={currentBlockType === "rolename" && type === "name" ? Style?.lineHeight : fontStyle?.lineHeight }
                  value={fontStyle?.lineHeight}
                  onChange={(val) => {
                    const num = parseFloat(val);
                    if (isNaN(num)) return;
                    const clamped = Math.min(Math.max(num, 0.8), 5.0);
                    // Temporary comment if Need common LineHeight then enable commented code
                    // if (targetFontStyleType === "role") {
                    //   dispatch(
                    //     updateFontStyleState(
                    //       "role",
                    //       "lineHeight",
                    //       clamped,
                    //       currentBlockType,
                    //     ),
                    //   );
                    //   debouncedSave("lineHeight", clamped, "role");
                    // } else {
                    //   updateFontState("lineHeight", clamped);
                    //   debouncedSave("lineHeight", clamped);
                    // }
                    updateFontState("lineHeight", clamped);
                    debouncedSave("lineHeight", clamped);
                  }}
                />
              </div>
              <div className="section2">
                <div className="w-full">
                  <ColorPicker
                    value={fontStyle?.color}
                    onChange={(val) => {
                      updateFontStateDebounced("color", val);
                    }}
                    onBlur={saveFonts}
                  />
                </div>
              </div>
            </div>

            {/* Row 4 – Letter Spacing + Margin Bottom */}
            <div className="main-section">
              <div className="section1">
                <img className="font-img" src={iconTwo} alt="" />
                <NumberInput_pointFont
                  step="0.1"
                  min="0.0"
                  max="4.9"
                  value={fontStyle?.letterSpacing}
                  onChange={(val) => {
                    updateFontState("letterSpacing", Number(val));
                    debouncedSave(
                      "letterSpacing",
                      parseFloat(val > -0.1 ? (val < 5.0 ? val : 0.0) : 4.9),
                    );
                  }}
                  inputBox
                />
              </div>
              <div className="section2">
                {label === "Heading" || label === "Sub-Heading" || label === "Song Title" || (label === "Name" && !isDoubleColumn) ? (
                  <div className="text-section">
                    <span
                      className="bg-gray"
                      style={{
                        color: "#fff",
                        fontSize: "18px",
                        marginRight: "8px",
                      }}
                    >
                      &darr;
                    </span>
                    <NumberInput_fontsize
                      step="1"
                      min="0"
                      max="15"
                      value={
                        fontStyle?.marginBottom ? fontStyle?.marginBottom : 0
                      }
                      onChange={(val) => {
                        updateFontState("marginBottom", Number(val));
                        debouncedSave(
                          "marginBottom",
                          parseInt(val > 0 ? (val < 100 ? val : 0) : 99),
                        );
                      }}
                      inputBox
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FontComponent;
